// removed by extract-text-webpack-plugin
module.exports = {"block":"_3_gW3DrTmHBKm5UkdY8Yw3","title":"_1GrkhH7_PTUNPDXjHcxHWp","score":"_5WFvPEIMhSv2cxe8RKnG5","scoreTable":"H4KF_sR3soODBy-evWh3N","radarPc":"v3r8fCBJiNcIS2EvZXkwh","radarSp":"VUxdaErKeIvRdqnPnBmGv","advice":"_1SWpe2Y6cRFtvlFRPCSdzq","button":"Vek7vOwFikDcSb51vpt_9"};


//////////////////
// WEBPACK FOOTER
// ./src/css/screens/result.css
// module id = 14
// module chunks = 0